import { Button, useNotify } from "react-admin";
import { Box, TextField, Typography } from "@mui/material";
import { accountRequests } from "api/accountApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const FindUserByPersonId = ({ personId, setPersonId, setFoundUsersInfo, setSelectedUserIndex, setShowForm }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();

  const searchUserByPersonId = async () => {
    if (!personId) {
      notify("Моля въведете валидно ЕГН!", { type: "error" });
      return;
    }
    try {
      const { data } = await dataProvider.customRequest(
        accountRequests.getUsersInfoList({ personIds: [personId] }),
        null,
        "GET",
      );
      const users = Array.isArray(data) ? data : [];
      if (users.length === 0) {
        notify("Потребителят не е намерен!", { type: "warning" });
        return;
      }
      setFoundUsersInfo(users);
      setSelectedUserIndex(0);
      setShowForm(true);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "50%",
        m: "0 auto",
        gap: 4,
      }}
    >
      <Typography
        sx={{ textAlign: "center", pt: "4rem", px: "1rem", pb: "1rem" }}
        color={"darkRed"}
        fontSize={24}
        fontWeight={"bold"}
      >
        Намери потребител
      </Typography>
      <Box sx={{ display: "flex", gap: 2, justifyContent: "center", alignItems: "center" }}>
        <TextField
          variant="outlined"
          sx={{ margin: "auto", width: "280px" }}
          label="ЕГН"
          name="personId"
          value={personId}
          onChange={e => setPersonId(e.target.value)}
          onKeyDown={e => e.key === "Enter" && searchUserByPersonId()}
        />
        <Button
          sx={{ margin: "auto", width: "130px" }}
          onClick={searchUserByPersonId}
          size="large"
          variant="contained"
        >
          Провери
        </Button>
        <Button
          sx={{ margin: "auto", width: "130px" }}
          onClick={() => {
            setFoundUsersInfo([]);
            setSelectedUserIndex(0);
            setShowForm(true);
            setPersonId("");
          }}
          size="large"
          variant="outlined"
        >
          Създай
        </Button>
      </Box>
    </Box>
  );
};

export default FindUserByPersonId;
